export type ProviderDrMode = {
  providerId: string;
  drMode: boolean;
};

export const getProviderDrMode = `
  query {
    getProviderDrMode {
      providerId
      drMode
    }
  }
`;
